import { render, staticRenderFns } from "./CockpitChartVendas.vue?vue&type=template&id=6f204fa2"
import script from "./CockpitChartVendas.vue?vue&type=script&lang=js"
export * from "./CockpitChartVendas.vue?vue&type=script&lang=js"
import style0 from "./CockpitChartVendas.vue?vue&type=style&index=0&id=6f204fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports